import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import posts from '../data/BlogPosts.json';
import './Blog.css';

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

function Blog() {
  const sortedPosts = [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div className="blog-page">
      <Helmet>
        <title>Blog - Szakacs Visuals</title>
        <meta
          name="description"
          content="Photography and videography tips, behind-the-scenes stories, and advice from Szakacs Visuals - Bristol wedding, real estate and commercial photographers."
        />
        <meta property="og:title" content="Blog - Szakacs Visuals" />
        <meta
          property="og:description"
          content="Photography and videography tips, behind-the-scenes stories, and advice from Szakacs Visuals."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/blog" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/blog" />
      </Helmet>

      <div className="blog-hero">
        <h1>Blog</h1>
        <p className="quote">Stories, tips, and a closer look behind the lens</p>
      </div>

      <div className="blog-grid">
        {sortedPosts.length === 0 && (
          <p className="blog-empty">New posts are on their way - check back soon.</p>
        )}
        {sortedPosts.map((post) => (
          <Link to={`/blog/${post.slug}`} className="blog-card" key={post.slug}>
            <div
              className="blog-card-image"
              style={{ backgroundImage: `url(${post.image})` }}
              role="img"
              aria-label={post.title}
            />
            <div className="blog-card-body">
              <span className="blog-card-date">{formatDate(post.date)}</span>
              <h2 className="blog-card-title">{post.title}</h2>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <span className="blog-card-readmore">READ MORE</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Blog;
